document.querySelectorAll("[data-section='carousel']").forEach(function (element) {
  let mainContainer = element.querySelector(".swiper-main");
  let asideContainer = element.querySelector(".swiper-aside");
  
  let configMain = JSON.parse(mainContainer.getAttribute("data-config"));
  let main = new Swiper(mainContainer, configMain);
  
  let configAside = JSON.parse(asideContainer.getAttribute("data-config"));
  let aside = new Swiper(asideContainer, configAside);
  
  main.controller.control = aside;
});

document.querySelectorAll("[data-section='collections']").forEach(function (element) {
  let mainContainer = element.querySelector(".swiper-main");
  
  let configMain = JSON.parse(mainContainer.getAttribute("data-config"));
  let main = new Swiper(mainContainer, configMain);
});

document.querySelectorAll("[data-section='video']").forEach(function (element) {
  let overlay = element.querySelector("button");
  let video = element.querySelector("video");
  
  overlay.addEventListener("click", function (e) {
    overlay.classList.add("hide");
    video.play();
    video.controls = true;
  });
  
  video.addEventListener("pause", function (e) {
    if(video.readyState == 4) {
      overlay.classList.remove("hide");
      video.pause();
      video.controls = false;
    }
  });

});
